import React from "react";
import image from "../images";
import { NavLink } from "react-router-dom";
import "../css/card.css";

function Card(pet) {
  return (
    <div>
      <NavLink className="family-link" to={`/info/${pet.pet._id}`}>
        <button className="animal-btn">
          <img className="animal-pic" src={pet.pet.petImageUrl} alt="pets-pic" />
          <img className="vector" src={image.vectorPeach} alt="vector" />
          <h2 className="animal-name">{pet.pet.petname}</h2>
          <p className="animal-breed">{pet.pet.breed}</p>
          <p className="animal-location">{pet.pet.address}</p>
        </button>
      </NavLink>
    </div>
  );
}

export default Card;
